import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { createAbuseReport } from '../../services';

type AbuseReportData = {
  contentObjectId?: string;
  paymentId?: string;
  programId?: string;
  transactionId?: string;
  userId?: string;
};

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Something went wrong. The report couldn’t be sent.');
};

export const useCreateAbuseReportMutation = () =>
  useMutation<unknown, AbuseReportData>({
    defaultMutateOnError,
    async mutationFn({ contentObjectId, paymentId, programId, transactionId, userId }) {
      const response = await createAbuseReport({
        body: {
          abuse_report: {
            content_object_id: contentObjectId,
            payment_id: paymentId,
            program_id: programId,
            transaction_item_id: transactionId,
            user_id: userId,
          },
        },
      });

      return response.data;
    },
  });
